<template>
  <div class="panel-list-page set-page" dir="rtl">
    <div class="pl-card">
      <div class="pl-card__header">
        <div class="pl-card__title-wrap">
          <span class="pl-card__icon" aria-hidden="true">
            <CIcon name="navSettings"/>
          </span>
          <div>
            <h1 class="pl-card__title">تنظیمات عمومی</h1>
            <p class="pl-card__sub">لوگو، رنگ، پیامک، درگاه پرداخت، ترب و موارد پایه فروشگاه</p>
          </div>
        </div>
        <div class="pl-toolbar">
          <button
            v-if="tab === 'sms'"
            type="button"
            class="pl-btn pl-btn--primary"
            :disabled="saving"
            @click="update_template()"
          >
            {{ saving ? 'در حال ذخیره...' : 'ذخیره پیامک' }}
          </button>
          <button
            v-else
            type="button"
            class="pl-btn pl-btn--primary"
            :disabled="saving || loading"
            @click="update_settings()"
          >
            {{ saving ? 'در حال ذخیره...' : 'ذخیره تغییرات' }}
          </button>
        </div>
      </div>

      <div class="pl-card__body">
        <div class="set-tabs" role="tablist">
          <button
            v-for="t in tabs"
            :key="t.id"
            type="button"
            class="set-tab"
            :class="{ active: tab === t.id }"
            role="tab"
            :aria-selected="tab === t.id"
            @click="tab = t.id"
          >{{ t.label }}</button>
        </div>

        <div v-if="loading" class="set-skel" aria-busy="true">
          <div v-for="n in 4" :key="'sk' + n" class="set-skel__row"></div>
        </div>

        <template v-else>
          <!-- عمومی -->
          <section v-show="tab === 'general'" class="set-section">
            <div class="set-block">
              <h2 class="set-block__title">هویت بصری</h2>
              <div class="set-grid set-grid--2">
                <div class="set-field">
                  <ImageSelector
                    label="لوگو"
                    :media_id.sync="logo_file"
                    default_archive="site"
                    :preview-image="site_config.logo || '/img/placeholder.png'"
                    @update:previewImage="onSiteLogoPreview"
                  />
                </div>
                <div class="set-field">
                  <ImageSelector
                    label="آیکن مرورگر (Favicon)"
                    :media_id.sync="favicon_file"
                    default_archive="site"
                    :preview-image="site_config.favicon || '/img/placeholder.png'"
                    @update:previewImage="onFaviconPreview"
                  />
                </div>
              </div>
              <div class="set-grid">
                <div class="set-field">
                  <span class="set-field__label">رنگ اصلی وبسایت</span>
                  <div class="set-color">
                    <input
                      v-model="primary_color"
                      type="color"
                      class="set-color__swatch"
                      title="انتخاب رنگ"
                      @input="onColorPick"
                    >
                    <input
                      v-model="primary_color"
                      class="set-input"
                      type="text"
                      dir="ltr"
                      placeholder="#2563eb"
                      @blur="normalizeColor"
                    >
                  </div>
                  <span class="set-field__hint">برای دکمه‌ها، لینک‌ها و عناصر برند در سایت استفاده می‌شود. روی مربع رنگ بزنید.</span>
                </div>
                <div class="set-field">
                  <span class="set-field__label">رنگ هاور / تیره‌تر</span>
                  <div class="set-color">
                    <input
                      v-model="primary_hover_color"
                      type="color"
                      class="set-color__swatch"
                      title="انتخاب رنگ"
                      @input="onHoverColorPick"
                    >
                    <input
                      v-model="primary_hover_color"
                      class="set-input"
                      type="text"
                      dir="ltr"
                      placeholder="#1d4ed8"
                      @blur="normalizeColor"
                    >
                  </div>
                  <span class="set-field__hint">رنگ دکمه‌ها و لینک‌ها در حالت هاور.</span>
                </div>
              </div>
            </div>

            <div class="set-block">
              <h2 class="set-block__title">اطلاعات تماس</h2>
              <div class="set-grid">
                <label class="set-field">
                  <span class="set-field__label">تلفن</span>
                  <input v-model="contact_phone" class="set-input" type="text" dir="ltr" placeholder="021...">
                </label>
                <label class="set-field">
                  <span class="set-field__label">ایمیل</span>
                  <input v-model="contact_email" class="set-input" type="email" dir="ltr" placeholder="info@...">
                </label>
                <label class="set-field set-field--grow">
                  <span class="set-field__label">آدرس</span>
                  <input v-model="contact_address" class="set-input" type="text" placeholder="آدرس فروشگاه">
                </label>
              </div>
            </div>

            <div class="set-block">
              <h2 class="set-block__title">فروش و آنالیتیکس</h2>
              <div class="set-grid">
                <label class="set-field">
                  <span class="set-field__label">درصد ارزش افزوده</span>
                  <input v-model="vat" class="set-input" type="number" min="0" max="100" step="0.1">
                </label>
                <label class="set-field set-field--grow">
                  <span class="set-field__label">کد گوگل آنالیتیکس / GA4</span>
                  <input v-model="google_analytics" class="set-input" type="text" dir="ltr" placeholder="G-XXXXXXXX">
                </label>
              </div>
            </div>
          </section>

          <!-- پیامک -->
          <section v-show="tab === 'sms'" class="set-section">
            <div class="set-block">
              <h2 class="set-block__title">sms.ir</h2>
              <p class="set-block__sub">کلید API به‌صورت رمزنگاری‌شده ذخیره می‌شود. برای تغییر، مقدار جدید را وارد کنید.</p>
              <div class="set-grid">
                <label v-for="temp in sms_templates" :key="temp.key" class="set-field" :class="{ 'set-field--grow': temp.key === 'api_key' || temp.key === 'admin_mobile' }">
                  <span class="set-field__label">{{ temp.name }}</span>
                  <input
                    v-model="temp.value"
                    class="set-input"
                    :type="temp.key === 'api_key' ? 'password' : 'text'"
                    :dir="temp.key === 'admin_mobile' ? 'ltr' : 'ltr'"
                    autocomplete="off"
                  >
                  <span v-if="temp.description" class="set-field__hint">{{ temp.description }}</span>
                </label>
              </div>
            </div>
          </section>

          <!-- پرداخت -->
          <section v-show="tab === 'payment'" class="set-section">
            <div class="set-block">
              <h2 class="set-block__title">درگاه پرداخت</h2>
              <div class="set-grid">
                <label class="set-field">
                  <span class="set-field__label">درگاه</span>
                  <select v-model="payment_gateway" class="set-input">
                    <option value="zarinpal">زرین‌پال</option>
                  </select>
                </label>
                <label class="set-field">
                  <span class="set-field__label">روش پرداخت</span>
                  <select v-model="payment_type" class="set-input">
                    <option value="1">درگاه آنلاین</option>
                    <option value="2">واریز به حساب</option>
                  </select>
                </label>
                <label class="set-field">
                  <span class="set-field__label">مهلت پرداخت</span>
                  <select v-model="payment_time" class="set-input">
                    <option v-for="h in paymentHours" :key="h" :value="String(h)">{{ h }} ساعت</option>
                  </select>
                </label>
                <label class="set-field">
                  <span class="set-field__label">حالت آزمایشی (Sandbox)</span>
                  <select v-model="payment_sandbox" class="set-input">
                    <option value="0">غیرفعال (عملیاتی)</option>
                    <option value="1">فعال</option>
                  </select>
                </label>
                <label class="set-field set-field--grow">
                  <span class="set-field__label">مرچنت‌آیدی زرین‌پال</span>
                  <input
                    v-model="zarinpal_merchant_id"
                    class="set-input"
                    type="password"
                    dir="ltr"
                    autocomplete="off"
                    placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                  >
                  <span class="set-field__hint">{{ zarinpal_merchant_hint || 'رمزنگاری‌شده ذخیره می‌شود؛ برای تغییر مقدار جدید وارد کنید' }}</span>
                </label>
              </div>
              <label class="set-field set-field--full">
                <span class="set-field__label">اطلاعات واریز به حساب</span>
                <textarea v-model="payment_deposit_info" class="set-textarea" rows="4" placeholder="شماره شبا، کارت، نام صاحب حساب..."></textarea>
              </label>
            </div>

            <div class="set-block">
              <h2 class="set-block__title">سفارش‌گیری</h2>
              <div class="set-grid">
                <label class="set-field">
                  <span class="set-field__label">وضعیت سفارش‌گیری</span>
                  <select v-model="holiday" class="set-input">
                    <option value="0">فعال</option>
                    <option value="1">غیرفعال (تعطیل)</option>
                  </select>
                </label>
                <label class="set-field set-field--grow">
                  <span class="set-field__label">پیام هنگام تعطیلی</span>
                  <input v-model="holiday_message" class="set-input" type="text" placeholder="در حال حاضر امکان ثبت سفارش وجود ندارد">
                </label>
              </div>
            </div>
          </section>

          <!-- ترب -->
          <section v-show="tab === 'torob'" class="set-section">
            <div class="set-block">
              <h2 class="set-block__title">اتصال ترب</h2>
              <p class="set-block__sub">این آدرس را در پنل ترب به‌عنوان منبع محصولات ثبت کنید.</p>
              <div class="set-feed">
                <span class="set-feed__label">لینک خوراک محصولات</span>
                <code class="set-feed__url" dir="ltr">{{ torob_feed_url }}</code>
                <button type="button" class="pl-btn pl-btn--sm pl-btn--ghost" @click="copyTorob">کپی لینک</button>
              </div>
              <div class="set-grid">
                <label class="set-field">
                  <span class="set-field__label">وضعیت خوراک</span>
                  <select v-model="torob_enabled" class="set-input">
                    <option value="1">فعال</option>
                    <option value="0">غیرفعال</option>
                  </select>
                </label>
                <label class="set-field set-field--grow">
                  <span class="set-field__label">کلید دسترسی (اختیاری)</span>
                  <input
                    v-model="torob_access_key"
                    class="set-input"
                    type="password"
                    dir="ltr"
                    autocomplete="off"
                    placeholder="خالی = بدون محدودیت"
                  >
                  <span class="set-field__hint">{{ torob_access_hint || 'در صورت تنظیم، درخواست‌ها باید ?key=... داشته باشند' }}</span>
                </label>
              </div>
            </div>
          </section>

          <!-- تصاویر -->
          <section v-show="tab === 'optimization'" class="set-section">
            <div class="set-block">
              <h2 class="set-block__title">بهینه‌سازی و کش</h2>
              <div class="set-grid">
                <label class="set-field">
                  <span class="set-field__label">مدت کش (ساعت)</span>
                  <input v-model="cache_ttl_hours" class="set-input" type="number" min="0" max="720" step="0.5" dir="ltr">
                  <span class="set-field__hint">مدت نگهداری داده‌های فروشگاه (پیش‌فرض ۱ ساعت)</span>
                </label>
                <label class="set-field">
                  <span class="set-field__label">بارگذاری تنبل تصاویر (Lazy Load)</span>
                  <input v-model="lazyload_enabled" type="checkbox" true-value="1" false-value="0">
                  <span class="set-field__hint">تصاویر غیر LCP فقط هنگام نزدیک شدن به نمایش بارگذاری می‌شوند</span>
                </label>
                <div class="set-field">
                  <span class="set-field__label">پاک کردن کش فروشگاه</span>
                  <button type="button" class="pl-btn" :disabled="clearing_cache" @click="clear_cache()">{{ clearing_cache ? '...' : 'پاک کردن کش' }}</button>
                  <span class="set-field__hint">نسخه کش: {{ cache_version }} — پس از پاک کردن، فروشگاه داده تازه می‌گیرد</span>
                </div>
              </div>
            </div>
          </section>

          <section v-show="tab === 'images'" class="set-section">
            <div class="set-block">
              <h2 class="set-block__title">پردازش تصاویر</h2>
              <p class="set-block__sub">برای محصولات و مقالات جدا تنظیم می‌شود. مثلاً مقالات واترمارک بگیرند و محصولات فقط به WebP تبدیل شوند.</p>
              <div class="set-tabs set-tabs--sub">
                <button
                  v-for="s in imageScopes"
                  :key="s.id"
                  type="button"
                  class="set-tab"
                  :class="{ active: image_scope === s.id }"
                  @click="image_scope = s.id"
                >{{ s.label }}</button>
              </div>

              <div class="img-layout">
                <div class="img-form">
                  <h3 class="img-form__title">واترمارک</h3>
                  <div class="set-grid">
                    <label class="set-field">
                      <span class="set-field__label">واترمارک</span>
                      <select v-model.number="activeProfile.watermark" class="set-input">
                        <option :value="0">خاموش</option>
                        <option :value="1">روشن</option>
                      </select>
                    </label>
                    <label class="set-field">
                      <span class="set-field__label">جایگاه لوگو</span>
                      <select v-model="activeProfile.position" class="set-input" :disabled="!activeProfile.watermark">
                        <option value="top_right">بالا راست</option>
                        <option value="top_left">بالا چپ</option>
                        <option value="bottom_right">پایین راست</option>
                        <option value="bottom_left">پایین چپ</option>
                        <option value="center">مرکز</option>
                      </select>
                    </label>
                    <label class="set-field">
                      <span class="set-field__label">عرض لوگو نسبت به عکس ({{ activeProfile.logo_width }}٪)</span>
                      <input
                        v-model.number="activeProfile.logo_width"
                        class="set-range"
                        type="range"
                        min="5"
                        max="50"
                        step="1"
                        :disabled="!activeProfile.watermark"
                      >
                    </label>
                  </div>
                  <ImageSelector
                    :key="image_scope"
                    label="لوگوی واترمارک"
                    :media_id.sync="logoMedia[image_scope]"
                    default_archive="site"
                    :preview-image="activeProfile.logo_url || '/img/placeholder.png'"
                    @update:previewImage="onLogoPreview"
                  />

                  <h3 class="img-form__title">تبدیل و اندازه</h3>
                  <div class="set-grid">
                    <label class="set-field">
                      <span class="set-field__label">خروجی WebP</span>
                      <select v-model.number="activeProfile.webp" class="set-input">
                        <option :value="0">خیر، فرمت اصلی بماند</option>
                        <option :value="1">بله، به WebP تبدیل شود</option>
                      </select>
                    </label>
                    <label class="set-field" v-if="activeProfile.webp">
                      <span class="set-field__label">حداکثر عرض (پیکسل)</span>
                      <input v-model.number="activeProfile.max_width" class="set-input" type="number" min="320" max="4000" step="10">
                      <span class="set-field__hint">اگر عکس پهن‌تر باشد، با حفظ نسبت به این عرض کوچک می‌شود</span>
                    </label>
                  </div>
                </div>

                <div class="img-preview">
                  <span class="set-field__label">پیش‌نمایش نمونه</span>
                  <div class="wm-stage" :class="{ 'is-off': !activeProfile.watermark }">
                    <div class="wm-scene" aria-hidden="true">
                      <span class="wm-scene__box"></span>
                      <span class="wm-scene__box wm-scene__box--sm"></span>
                    </div>
                    <img
                      v-if="activeProfile.watermark && activeProfile.logo_url && activeProfile.logo_url !== '/img/placeholder.png'"
                      class="wm-logo"
                      :class="'is-' + activeProfile.position"
                      :src="activeProfile.logo_url"
                      alt=""
                      :style="{ width: activeProfile.logo_width + '%' }"
                    >
                    <span
                      v-else-if="activeProfile.watermark"
                      class="wm-logo wm-logo--ph"
                      :class="'is-' + activeProfile.position"
                      :style="{ width: activeProfile.logo_width + '%' }"
                    >لوگو</span>
                  </div>
                  <p class="set-field__hint">
                    {{ activeProfile.watermark ? 'لوگو با همین عرض و جایگاه روی عکس قرار می‌گیرد.' : 'واترمارک برای این بخش خاموش است.' }}
                    {{ activeProfile.webp ? 'خروجی WebP با حداکثر عرض ' + activeProfile.max_width + ' پیکسل.' : 'فرمت فایل عوض نمی‌شود.' }}
                  </p>
                </div>
              </div>
            </div>
          </section>

          <!-- ظاهر پنل -->
          <section v-show="tab === 'panel'" class="set-section">
            <div class="set-block">
              <h2 class="set-block__title">تم پنل مدیریت</h2>
              <p class="set-block__sub">فقط ظاهر پنل ادمین را تغییر می‌دهد؛ روی سایت اثر ندارد.</p>
              <div class="panel-theme-setting__toggle">
                <button
                  type="button"
                  class="panel-theme-setting__btn"
                  :class="{ 'is-active': theme === 'light' }"
                  @click="$store.commit('setTheme', 'light')"
                >
                  <CIcon name="iconSun"/>
                  <span>روشن</span>
                </button>
                <button
                  type="button"
                  class="panel-theme-setting__btn"
                  :class="{ 'is-active': theme === 'dark' }"
                  @click="$store.commit('setTheme', 'dark')"
                >
                  <CIcon name="iconMoon"/>
                  <span>تاریک</span>
                </button>
              </div>
            </div>
          </section>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl } from '@/api/config'
import axios from '@/api/http'

export default {
  name: 'Settings',
  data() {
    return {
      tab: 'general',
      cache_ttl_hours: '1',
      lazyload_enabled: '1',
      cache_version: 1,
      clearing_cache: false,
      tabs: [
        { id: 'general', label: 'عمومی' },
        { id: 'sms', label: 'پیامک (sms.ir)' },
        { id: 'payment', label: 'پرداخت' },
        { id: 'torob', label: 'ترب' },
        { id: 'optimization', label: 'بهینه‌سازی' },
        { id: 'images', label: 'تصاویر' },
        { id: 'panel', label: 'ظاهر پنل' },
      ],
      loading: true,
      saving: false,
      image_scope: 'products',
      imageScopes: [
        { id: 'products', label: 'محصولات' },
        { id: 'articles', label: 'مقالات' },
        { id: 'sliders', label: 'اسلایدر' },
        { id: 'banners', label: 'بنر / صفحه اصلی' },
      ],
      image_profiles: {
        products: { watermark: 0, position: 'bottom_right', logo_id: null, logo_url: '', logo_width: 18, webp: 0, max_width: 1600 },
        articles: { watermark: 0, position: 'bottom_right', logo_id: null, logo_url: '', logo_width: 18, webp: 0, max_width: 1600 },
        sliders: { watermark: 0, position: 'bottom_right', logo_id: null, logo_url: '', logo_width: 18, webp: 1, max_width: 1920 },
        banners: { watermark: 0, position: 'bottom_right', logo_id: null, logo_url: '', logo_width: 18, webp: 1, max_width: 1920 },
      },
      logoMedia: { products: null, articles: null, sliders: null, banners: null },
      payment_type: '1',
      payment_time: '24',
      payment_deposit_info: '',
      payment_sandbox: '0',
      payment_gateway: 'zarinpal',
      zarinpal_merchant_id: '',
      zarinpal_merchant_hint: '',
      holiday: '0',
      holiday_message: '',
      site_config: { logo: '', favicon: '', titles: [] },
      vat: '0',
      google_analytics: '',
      primary_color: '#2563eb',
      primary_hover_color: '#1d4ed8',
      contact_phone: '',
      contact_email: '',
      contact_address: '',
      sms_templates: [],
      logo_file: null,
      favicon_file: null,
      torob_enabled: '0',
      torob_access_key: '',
      torob_access_hint: '',
      torob_feed_url: apiUrl('api/market/torob/products'),
      paymentHours: [1, 2, 4, 8, 12, 24, 48],
    }
  },
  computed: {
    theme() {
      return this.$store.state.theme
    },
    activeProfile() {
      return this.image_profiles[this.image_scope]
    },
  },
  mounted() {
    this.get_data()
  },
  methods: {
    onColorPick(e) {
      this.primary_color = e.target.value
    },
    normalizeHex(val, fallback) {
      let v = String(val || '').trim()
      if (/^#[0-9a-fA-F]{3}$/.test(v)) {
        v = '#' + v[1] + v[1] + v[2] + v[2] + v[3] + v[3]
      }
      if (!/^#[0-9a-fA-F]{6}$/.test(v)) v = fallback
      return v.toLowerCase()
    },
    normalizeColor() {
      this.primary_color = this.normalizeHex(this.primary_color, '#2563eb')
      this.primary_hover_color = this.normalizeHex(this.primary_hover_color, '#1d4ed8')
    },
    onHoverColorPick(e) {
      this.primary_hover_color = e.target.value
    },
    copyTorob() {
      const url = this.torob_feed_url
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          if (this.$toast) this.$toast.open({ message: 'لینک کپی شد', type: 'success' })
        }).catch(() => {})
      } else {
        window.prompt('کپی کنید:', url)
      }
    },
    get_data() {
      this.loading = true
      axios.post('/api/admin/site/get_config', new FormData(), {}).then((response) => {
        const d = response.data || {}
        this.site_config = d.configs || { logo: '', favicon: '', titles: [] }
        this.sms_templates = d.sms_templates || []
        this.vat = d.vat != null ? String(d.vat) : '0'
        this.google_analytics = d.google_analytics || ''
        this.cache_ttl_hours = d.cache_ttl_hours != null ? String(d.cache_ttl_hours) : '1'
        this.lazyload_enabled = d.lazyload_enabled === '0' ? '0' : '1'
        this.cache_version = d.cache_version || 1
        this.primary_color = d.primary_color || '#2563eb'
        this.primary_hover_color = d.primary_hover_color || '#1d4ed8'
        this.contact_phone = d.contact_phone || ''
        this.contact_email = d.contact_email || ''
        this.contact_address = d.contact_address || ''
        this.payment_type = d.payment_type != null ? String(d.payment_type) : '1'
        this.payment_time = d.payment_time != null ? String(d.payment_time) : '24'
        this.payment_deposit_info = d.payment_deposit_info || ''
        this.payment_sandbox = d.payment_sandbox === '1' ? '1' : '0'
        this.payment_gateway = d.payment_gateway || 'zarinpal'
        this.zarinpal_merchant_id = d.zarinpal_merchant_id || ''
        this.zarinpal_merchant_hint = d.zarinpal_merchant_hint || ''
        this.holiday = d.holiday != null ? String(d.holiday) : '0'
        this.holiday_message = d.holiday_message || ''
        this.torob_enabled = d.torob_enabled === '1' ? '1' : '0'
        this.torob_access_key = d.torob_access_key || ''
        this.torob_access_hint = d.torob_access_hint || ''
        if (d.torob_feed_url) this.torob_feed_url = d.torob_feed_url

        if (d.configs && d.configs.logo_id) this.logo_file = [d.configs.logo_id]
        if (d.configs && d.configs.favicon_id) this.favicon_file = [d.configs.favicon_id]
        if (d.configs && d.configs.logo) {
          localStorage.setItem('logo_url', d.configs.logo)
          window.dispatchEvent(new CustomEvent('site-logo', { detail: d.configs.logo }))
        }

        const blank = () => ({ watermark: 0, position: 'bottom_right', logo_id: null, logo_url: '', logo_width: 18, webp: 0, max_width: 1600 })
        const incoming = d.image_profiles || {}
        ;['products', 'articles', 'sliders', 'banners'].forEach((scope) => {
          const src = incoming[scope] || {}
          const row = Object.assign(blank(), src)
          row.watermark = Number(row.watermark) ? 1 : 0
          row.webp = Number(row.webp) ? 1 : 0
          row.logo_width = Math.min(50, Math.max(5, Number(row.logo_width) || 18))
          row.max_width = Math.min(4000, Math.max(320, Number(row.max_width) || 1600))
          this.$set(this.image_profiles, scope, row)
          this.$set(this.logoMedia, scope, row.logo_id ? [row.logo_id] : null)
        })
      }).catch((error) => {
        console.log(error)
      }).finally(() => {
        this.loading = false
      })
    },
    onSiteLogoPreview(url) {
      if (!url || url.indexOf('placeholder') >= 0) return
      if (!this.site_config) this.site_config = {}
      this.$set(this.site_config, 'logo', url)
    },
    onFaviconPreview(url) {
      if (!url || url.indexOf('placeholder') >= 0) return
      if (!this.site_config) this.site_config = {}
      this.$set(this.site_config, 'favicon', url)
    },
    onLogoPreview(url) {
      if (!this.activeProfile) return
      this.$set(this.activeProfile, 'logo_url', url || '')
    },
    update_settings() {
      this.normalizeColor()
      this.saving = true
      const formData = new FormData()
      formData.append('site_config', JSON.stringify(this.site_config || {}))
      const mediaId = (v) => (Array.isArray(v) ? v[0] : v)
      if (mediaId(this.logo_file)) formData.append('logo_file', mediaId(this.logo_file))
      if (mediaId(this.favicon_file)) formData.append('favicon_file', mediaId(this.favicon_file))
      formData.append('primary_color', this.primary_color)
      formData.append('primary_hover_color', this.primary_hover_color)
      formData.append('vat', this.vat)
      formData.append('google_analytics', this.google_analytics)
      formData.append('cache_ttl_hours', this.cache_ttl_hours)
      formData.append('lazyload_enabled', this.lazyload_enabled)
      formData.append('contact_phone', this.contact_phone)
      formData.append('contact_email', this.contact_email)
      formData.append('contact_address', this.contact_address)
      formData.append('payment_type', this.payment_type)
      formData.append('payment_time', this.payment_time)
      formData.append('payment_deposit_info', this.payment_deposit_info)
      formData.append('payment_sandbox', this.payment_sandbox)
      formData.append('payment_gateway', this.payment_gateway)
      formData.append('zarinpal_merchant_id', this.zarinpal_merchant_id)
      formData.append('holiday', this.holiday)
      formData.append('holiday_message', this.holiday_message)
      formData.append('torob_enabled', this.torob_enabled)
      formData.append('torob_access_key', this.torob_access_key)
      const profiles = {}
      ;['products', 'articles', 'sliders', 'banners'].forEach((scope) => {
        const src = this.image_profiles[scope] || {}
        const logo = Array.isArray(this.logoMedia[scope]) ? this.logoMedia[scope][0] : null
        profiles[scope] = {
          watermark: Number(src.watermark) ? 1 : 0,
          position: src.position || 'bottom_right',
          logo_id: logo || src.logo_id || null,
          logo_width: Math.min(50, Math.max(5, Number(src.logo_width) || 18)),
          webp: Number(src.webp) ? 1 : 0,
          max_width: Math.min(4000, Math.max(320, Number(src.max_width) || 1600)),
        }
      })
      formData.append('image_profiles', JSON.stringify(profiles))

      axios.post('/api/admin/site/update_config', formData, {}).then((res) => {
        if (this.$root.modal_component) this.$root.modal_component.show_api_response_modals(res)
        this.get_data()
      }).catch((error) => {
        console.log(error)
      }).finally(() => {
        this.saving = false
      })
    },
    clear_cache() {
      this.clearing_cache = true
      axios.post('/api/admin/site/cache/clear', new FormData(), {}).then((res) => {
        if (res.data && res.data.cache_version) this.cache_version = res.data.cache_version
        if (this.$root.modal_component) this.$root.modal_component.show_api_response_modals(res)
      }).catch((e) => { console.log(e) }).finally(() => { this.clearing_cache = false })
    },
    update_template() {
      this.saving = true
      const formData = new FormData()
      formData.append('templates', JSON.stringify(this.sms_templates))
      axios.post('/api/admin/site/update_config_sms', formData, {}).then((res) => {
        if (this.$root.modal_component) this.$root.modal_component.show_api_response_modals(res)
        if (res.data && res.data.sms_templates) this.sms_templates = res.data.sms_templates
      }).catch((error) => {
        console.log(error)
      }).finally(() => {
        this.saving = false
      })
    },
  },
}
</script>

<style scoped>
.set-page {
  max-width: 960px;
}

.set-tabs--sub {
  margin-bottom: 14px;
}

.img-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(260px, .8fr);
  gap: 16px;
  align-items: start;
}

.img-form__title {
  margin: 14px 0 10px;
  font-size: 13px;
  font-weight: 800;
  color: var(--panel-text, #111827);
}

.img-form__title:first-child {
  margin-top: 0;
}

.set-range {
  width: 100%;
  accent-color: #111111;
}

.wm-stage {
  position: relative;
  margin-top: 6px;
  aspect-ratio: 4 / 3;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--panel-border, #e5e7eb);
  background: linear-gradient(160deg, #dbe7f5 0%, #f8fafc 55%, #e7eef6 100%);
}

.wm-stage.is-off {
  opacity: .85;
}

.wm-scene {
  position: absolute;
  inset: 14% 18% 16%;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, .08);
}

.wm-scene__box {
  position: absolute;
  left: 18%;
  right: 18%;
  top: 16%;
  height: 42%;
  border-radius: 12px;
  background: linear-gradient(180deg, #93c5fd, #1d4ed8);
}

.wm-scene__box--sm {
  top: auto;
  bottom: 14%;
  height: 14%;
  background: #e5e7eb;
}

.wm-logo {
  position: absolute;
  height: auto;
  max-height: 40%;
  object-fit: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, .18));
}

.wm-logo--ph {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  border-radius: 8px;
  background: rgba(255, 255, 255, .9);
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.wm-logo.is-top_left { top: 6%; left: 6%; }
.wm-logo.is-top_right { top: 6%; right: 6%; }
.wm-logo.is-bottom_left { bottom: 6%; left: 6%; }
.wm-logo.is-bottom_right { bottom: 6%; right: 6%; }
.wm-logo.is-center { top: 50%; left: 50%; transform: translate(-50%, -50%); }

.img-preview .set-field__hint {
  margin-top: 8px;
}

.set-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 16px;
  padding: 4px;
  border: 1px solid var(--panel-border, #e5e7eb);
  border-radius: 12px;
  background: var(--panel-surface-2, #f8fafc);
}

.set-tab {
  border: 0;
  background: transparent;
  color: var(--panel-muted, #6b7280);
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  min-height: 36px;
  padding: 8px 12px;
  border-radius: 10px;
  cursor: pointer;
}

.set-tab.active {
  background: #111111;
  color: #fff;
}

.set-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.set-block {
  border: 1px solid var(--panel-border, #e5e7eb);
  border-radius: 12px;
  padding: 14px;
  background: var(--panel-surface, #fff);
  box-shadow: none;
}

.set-block__title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 800;
  color: var(--panel-text, #111827);
}

.set-block__sub {
  margin: 0 0 12px;
  font-size: 12px;
  color: var(--panel-muted, #6b7280);
  line-height: 1.6;
}

.set-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.set-grid--2 > .set-field {
  flex: 1 1 240px;
}

.set-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 160px;
  flex: 1 1 180px;
}

.set-field--grow {
  flex: 1 1 280px;
}

.set-field--full {
  flex: 1 1 100%;
  margin-top: 12px;
}

.set-field__label {
  font-size: 12px;
  font-weight: 700;
  color: var(--panel-muted, #6b7280);
}

.set-field__hint {
  font-size: 11px;
  color: var(--panel-muted, #9ca3af);
  line-height: 1.5;
}

.set-input,
.set-textarea {
  width: 100%;
  min-height: 38px;
  padding: 8px 10px;
  border: 1px solid var(--panel-border, #e5e7eb);
  border-radius: 10px;
  background: var(--panel-surface, #fff);
  color: var(--panel-text, #111827);
  font-family: inherit;
  font-size: 13px;
  outline: none;
  box-shadow: none;
}

.set-input:focus,
.set-textarea:focus {
  border-color: #111111;
}

.set-textarea {
  min-height: 100px;
  resize: vertical;
  line-height: 1.6;
}

.set-color {
  display: flex;
  align-items: center;
  gap: 8px;
}

.set-color__swatch {
  width: 42px;
  height: 42px;
  padding: 0;
  border: 1px solid var(--panel-border, #e5e7eb);
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  appearance: none;
  -webkit-appearance: none;
}

.set-color__swatch::-webkit-color-swatch-wrapper {
  padding: 0;
}

.set-color__swatch::-webkit-color-swatch {
  border: none;
  border-radius: 8px;
}

.set-color__swatch::-moz-color-swatch {
  border: none;
  border-radius: 8px;
}

.set-feed {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  padding: 10px 12px;
  border-radius: 10px;
  background: var(--panel-surface-2, #f8fafc);
  border: 1px solid var(--panel-border, #e5e7eb);
}

.set-feed__label {
  font-size: 12px;
  font-weight: 700;
  color: var(--panel-muted, #6b7280);
}

.set-feed__url {
  flex: 1 1 220px;
  font-size: 12px;
  word-break: break-all;
  color: var(--panel-text, #111827);
}

.set-skel {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.set-skel__row {
  height: 72px;
  border-radius: 12px;
  background: linear-gradient(90deg, #f1f5f9 25%, #e5e7eb 37%, #f1f5f9 63%);
  background-size: 400% 100%;
  animation: set-shimmer 1.2s ease infinite;
}

@keyframes set-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: 0 0; }
}

.panel-theme-setting__toggle {
  display: inline-flex;
  gap: 8px;
  padding: 4px;
  border-radius: 12px;
  background: var(--panel-surface-2, #f3f5f9);
  border: 1px solid var(--panel-border, rgba(128, 148, 174, .14));
}

.panel-theme-setting__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 36px;
  padding: 8px 14px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--panel-nav, #6e82a5);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.panel-theme-setting__btn .c-icon {
  width: 16px;
  height: 16px;
}

.panel-theme-setting__btn.is-active {
  background: var(--panel-surface, #fff);
  color: #111111;
  box-shadow: none;
}

@media (max-width: 860px) {
  .img-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 575.98px) {
  .set-tabs {
    overflow-x: auto;
    flex-wrap: nowrap;
  }
  .set-tab {
    flex-shrink: 0;
  }
}
</style>
